import { VideoProgressStatus } from './VideoUploadProgressBar.types';

export const videoFormatToReadableString: Record<VideoProgressStatus, string> =
    {
        NOT_STARTED: 'Queueing',
        QUEUED: 'Queued',
        IN_PROGRESS: 'Converting',
        COMPLETE: 'Finished',
        FAILED: 'Failed',
    };
